export default __webpack_public_path__ + "static/settings-light-b7d7539aab19e472bd4a7ef324082a22.png";